module.exports = new __parcel__URL__("CineBriqueVQ.0d68f6c0.avif").toString();